module.exports = __webpack_public_path__ + "img/salute.08d0f33e.gif";